import { createReadonlyProvider } from 'apprise-frontend-core/state/factory';


export type TimeContext = {

    tz: string
    defaultFormat: string
}

export const defaultTimeContext: TimeContext = { tz: 'Etc/UTC', defaultFormat: 'default' }



export const [TimeProvider, useTimeProvider] = createReadonlyProvider<TimeContext>(defaultTimeContext)



